import React from 'react';
import { STAGES } from '../../data/roadmapContent';
import type { Stage } from '../../data/roadmapContent';
interface ProgressBarProps {
  step: number;
  total: number;
  stage: Stage;
}
export function ProgressBar({
  step,
  total,
  stage
}: ProgressBarProps) {
  const percent = Math.round(step / total * 100);
  const stageIndex = STAGES.indexOf(stage);
  return <div className="mb-8" data-id="element-231" data-mp="1l4lrfgeybg3v">
      <div className="flex items-baseline justify-between mb-2.5" data-id="element-232" data-mp="17auhi6xb5u7m">
        <p className="text-sm font-medium text-slate-500 dark:text-slate-400" data-id="element-233" data-mp="179jcy4w1gifg">
          {stage}
        </p>
        <p className="text-sm font-semibold text-primary-600 dark:text-primary-400" data-id="element-234" data-mp="xd7zhbkppmjf">
          {percent}%
        </p>
      </div>

      <div className="h-2 w-full rounded-full bg-slate-200 dark:bg-white/10 overflow-hidden" role="progressbar" aria-valuenow={step} aria-valuemin={0} aria-valuemax={total} aria-label={`Step ${step} of ${total}`} data-id="element-235" data-mp="12bhvtpi6at6m">
        <div className="h-full rounded-full bg-gradient-to-r from-accent-500 to-primary-500 transition-[width] duration-300 ease-out" style={{
        width: `${percent}%`
      }} data-id="element-236" data-mp="2kiwccw48iksy" />
      </div>

      {/* Stage markers: which part of the conversation we're in, not just how
          far along. Hidden on the narrowest screens where six labels won't fit
          without wrapping. */}
      <ol className="hidden sm:flex items-center gap-1.5 mt-3" data-id="element-237" data-mp="21rvfqeql71ck">
        {STAGES.map((label, index) => <li key={label} className={`h-1 flex-1 rounded-full ${index <= stageIndex ? 'bg-primary-500/60' : 'bg-slate-200 dark:bg-white/10'}`} data-id="element-238" data-mp="1wu3daqsbfwu4" data-mpi={index}>
            <span className="sr-only" data-id="element-239" data-mp="26rrjccvdgqrl">
              {label}
              {index === stageIndex ? ' (current)' : ''}
            </span>
          </li>)}
      </ol>

      <p className="mt-3 text-xs text-slate-400 dark:text-slate-500" data-id="element-240" data-mp="1izsx4xudxazo">
        Step {step} of {total}
      </p>
    </div>;
}